const combineLabel = values => {
  return values.length === 1 ? values[0] : `${values[0]} (${values[1]})`
}

const getCombinedOption = (data, properties, subProperty = null) => {
  if (!data) {
    return {}
  }

  return subProperty
    ? {
        value: data.id,
        label: `${data[subProperty][properties[0]]} (${
          data[subProperty][properties[1]]
        })`
      }
    : {
        value: data.id,
        label: `${data[properties[0]]} (${data[properties[1]]})`
      }
}

const getInitialValue = (value, label) => {
  return { value, label }
}

const getOptions = (data, properties) => {
  return data
    ? data.map(d => {
        return {
          value: d.id,
          label: combineLabel(properties.map(prop => d[prop]))
        }
      })
    : []
}

const getAssociatedOptions = (
  options,
  theOption,
  associatedSetName,
  properties,
  subProperty = null
) => {
  const value = theOption?.value

  if (!options || !value) {
    return []
  }

  const firstJoinedObject = options?.find(d => d.id === value)

  if (subProperty) {
    return firstJoinedObject[associatedSetName]?.map(val => {
      return {
        value: val.id,
        label: combineLabel(properties?.map(prop => val[subProperty][prop]))
      }
    })
  }

  return firstJoinedObject[associatedSetName]?.map(val => {
    return {
      value: val?.id,
      label: combineLabel(properties?.map(prop => val[prop]))
    }
  })
}

export { getCombinedOption, getOptions, getAssociatedOptions, getInitialValue }
